import type { Service } from '../types/content'

export const services: Service[] = [
  {
    id: 'web-conversion',
    title: 'Páginas web de alta conversión',
    description:
      'Diseño páginas web modernas, rápidas y optimizadas para convertir visitantes en prospectos. Incluyen copy persuasivo, estructura estratégica, formularios de solicitud, conexión a WhatsApp, redes sociales y llamados a la acción claros.',
    icon: 'monitor',
  },
  {
    id: 'landing-servicios',
    title: 'Landing pages para servicios',
    description:
      'Creamos páginas enfocadas en negocios de limpieza, gimnasios, salones de belleza, estética, uñas, servicios profesionales y negocios locales que necesitan recibir cotizaciones, llamadas o mensajes.',
    icon: 'target',
  },
  {
    id: 'google-business',
    title: 'Google Business Profile',
    description:
      'Creamos y optimizamos cuentas de Google Business para que tu negocio tenga presencia profesional en Google, pueda aparecer en búsquedas locales y facilite que los clientes te contacten.',
    icon: 'map-pin',
  },
  {
    id: 'google-ads',
    title: 'Google Ads y campañas digitales',
    description:
      'Configuramos campañas en Google Ads enfocadas en atraer personas interesadas en tus servicios, mejorar la visibilidad de tu negocio y generar oportunidades reales de venta.',
    icon: 'megaphone',
  },
  {
    id: 'seo',
    title: 'SEO básico',
    description:
      'Realizamos análisis SEO básico, estructura de contenido, títulos, descripciones y optimización inicial para que tu página tenga una base sólida en buscadores.',
    icon: 'search',
  },
  {
    id: 'redes',
    title: 'Administración de redes sociales',
    description:
      'Apoyamos la presencia digital de tu marca en Instagram y Facebook con contenido, organización visual, estrategia básica y conexión con tu página web.',
    icon: 'instagram',
  },
  {
    id: 'productos-digitales',
    title: 'Páginas para vender productos digitales',
    description:
      'Creamos páginas persuasivas para vender ebooks, cursos, guías, membresías, plantillas u otros productos digitales, con estructura enfocada en conversión.',
    icon: 'book-open',
  },
  {
    id: 'shopify',
    title: 'Integración con Shopify',
    description:
      'Podemos conectar landing pages o páginas de venta con tiendas Shopify para vender productos físicos o digitales, facilitando el proceso de compra y presentación profesional de la marca.',
    icon: 'shopping-bag',
  },
]
